export const getCityValues = (city) => {
  if (Array.isArray(city)) return city;
  return city ? [city] : [];
};

export const getLocationErrorKey = (index, field) => `${index}.${field}`;

export const getCitiesBySelectedState = (locationData, state) =>
  locationData?.find(
    (location) => location?.state?.toLowerCase() === state?.toLowerCase()
  )?.city || [];

export const getVendorSelectFields = ({
  stateOptions,
  cityOptions,
  clubOptions,
  companySizeOptions,
  isCityDisabled,
}) => [
  {
    label: "State",
    name: "state",
    options: stateOptions,
    placeholder: "Select State",
    disabled: false,
  },
  {
    label: "City",
    name: "city",
    options: cityOptions,
    placeholder: "Select City",
    disabled: isCityDisabled,
  },
  {
    label: "Club",
    name: "club",
    options: clubOptions,
    placeholder: "Select Club",
    disabled: false,
  },
  {
    label: "Company Size",
    name: "company_size",
    options: companySizeOptions,
    placeholder: "Select Company Size",
    disabled: false,
  },
];
